import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import Cookies from 'js-cookie';
import '../ChatApp.css';

const LandingPagePreview = ({ ViewedPage, shop_domain, app_url }) => {
  ViewedPage(51);

  const [landingPages, setLandingPages] = useState([]);
  const [selectedLp, setSelectedLp]     = useState('');
  const [generating, setGenerating]     = useState(false);
  const [previewUrl, setPreviewUrl]     = useState('');
  const [copied, setCopied]             = useState(false);
  const [error, setError]               = useState('');
  const [loadingPages, setLoadingPages] = useState(false);
  const [activeAccordionKeys, setActiveAccordionKeys] = useState(['0']);

  const shop = shop_domain || Cookies.get('shop');

  useEffect(() => {
    if (!shop) return;
    setLoadingPages(true);
    axios.get(`${app_url}/api/dev/landing-page-urls/${shop}`, { withCredentials: true })
      .then(res => { if (res.data.success) setLandingPages(res.data.data || []); })
      .catch(() => setLandingPages([]))
      .finally(() => setLoadingPages(false));
  }, [shop]);

  useEffect(() => {
    if (!selectedLp || !shop) { setPreviewUrl(''); return; }
    axios.get(`${app_url}/api/dev/lp-preview/saved`, {
      params: { shop, lp: selectedLp },
      withCredentials: true,
    }).then(res => {
      const url = res.data.success ? (res.data.preview_url || '') : '';
      setPreviewUrl(url);
      if (url) setActiveAccordionKeys(prev => prev.includes('1') ? prev : [...prev, '1']);
    }).catch(() => setPreviewUrl(''));
  }, [selectedLp, shop]);

  const handleAccordionSelect = (key) => {
    if (key === null) { setActiveAccordionKeys([]); return; }
    const keys = Array.isArray(key) ? key : [key];
    setActiveAccordionKeys(prev =>
      prev.includes(keys[0]) ? prev.filter(k => k !== keys[0]) : [...prev, keys[0]]
    );
  };

  const handleGenerate = async () => {
    if (!selectedLp || generating) return;
    setGenerating(true);
    setError('');
    try {
      const res = await axios.post(`${app_url}/api/dev/lp-preview/generate`,
        { lp_url: selectedLp }, { withCredentials: true });
      if (res.data.success) {
        setPreviewUrl(res.data.preview_url);
        setActiveAccordionKeys(prev => prev.includes('1') ? prev : [...prev, '1']);
      } else setError(res.data.message || 'Generation failed');
    } catch (e) {
      setError(e.response?.data?.message || 'Generation failed');
    } finally {
      setGenerating(false);
    }
  };

  const previewBaseUrl = (() => {
    try { const u = new URL(previewUrl); return u.origin + u.pathname; } catch { return previewUrl; }
  })();

  return (
    <div className='main-container'>
      {!shop_domain ? (
        <div className='go_to_shopify_admin_div'>
          <h5 style={{ display: 'inline-block' }}>!! Go to Shopify Admin and open our app !!</h5>
        </div>
      ) : (
        <>
          <Container fluid className="mx-0">
            <Row className="mb-4">
              <Col className="d-flex align-items-center justify-content-between">
                <div className="custom-campaign-personalization-title d-flex justify-content-between align-items-start w-100 px-3">
                  <div className="d-flex flex-column">
                    <h2 style={{ marginBottom: 0, fontSize: '1.40rem', fontWeight: 'bold', color: '#052c65' }}>
                      LP Preview
                    </h2>
                    <p style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: 0, marginTop: 4 }}>
                      Generate a combined preview of all sections for a landing page
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>

          <div className='main-accordion-body mt-4 p-2'>
            <Accordion activeKey={activeAccordionKeys} onSelect={handleAccordionSelect}>

              {/* Landing Page Selection */}
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="sxi-accordion-header-with-icon">
                      <div className="sxi-accordion-header-icon" aria-hidden="true">
                        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g filter="url(#filter0_d_lp_preview)">
                            <rect x="3" y="3" width="48" height="48" rx="6" fill="#E5EEFF" shapeRendering="crispEdges" />
                            <rect x="3" y="3" width="48" height="48" rx="6" stroke="#CEDEFF" shapeRendering="crispEdges" />
                            <path d="M20 30h18M20 24h18M20 18h10" stroke="#2056C1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </g>
                          <defs>
                            <filter id="filter0_d_lp_preview" x="0.5" y="0.5" width="57" height="57" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                              <feFlood floodOpacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                              <feOffset dx="2" dy="2" />
                              <feGaussianBlur stdDeviation="2" />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_lp_preview" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_lp_preview" result="shape" />
                            </filter>
                          </defs>
                        </svg>
                      </div>
                      <span style={{ fontWeight: 600, fontSize: '0.95rem' }}>Landing Page Selection</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className={`campaign-accordion-chevron ${activeAccordionKeys.includes('0') ? 'open' : ''}`} aria-hidden="true">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <Container fluid className="px-0">
                    <Row className="mb-2 mt-3">
                      <Col xs={12} md={8} className="mb-3 mb-md-0">
                        {loadingPages ? (
                          <div className="d-flex align-items-center gap-2" style={{ color: '#6c757d', fontSize: 14 }}>
                            <Spinner size="sm" animation="border" />
                            <span>Loading landing pages…</span>
                          </div>
                        ) : (
                          <select
                            className="form-control"
                            value={selectedLp}
                            onChange={e => setSelectedLp(e.target.value)}
                          >
                            <option value="">— Select a landing page —</option>
                            {landingPages.map(lp => (
                              <option key={lp} value={lp}>{lp}</option>
                            ))}
                          </select>
                        )}
                      </Col>
                      <Col xs={12} md={4} className="d-flex align-items-end">
                        <Button
                          className="sxi_primary_blue_btn btn-height"
                          onClick={handleGenerate}
                          disabled={!selectedLp || generating}
                        >
                          {generating ? (
                            <>
                              <Spinner size="sm" animation="border" style={{ marginRight: 6 }} />
                              Generating…
                            </>
                          ) : 'Generate LP Preview'}
                        </Button>
                      </Col>
                    </Row>

                    {error && (
                      <Row className="mt-2">
                        <Col>
                          <div style={{
                            padding: '10px 14px', background: '#fff3cd',
                            border: '1px solid #ffc107', borderRadius: 6,
                            fontSize: 13, color: '#856404',
                          }}>
                            {error}
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Container>
                </Accordion.Body>
              </Accordion.Item>

              {/* Preview URL */}
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="sxi-accordion-header-with-icon">
                      <div className="sxi-accordion-header-icon" aria-hidden="true">
                        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g filter="url(#filter0_d_lp_url)">
                            <rect x="3" y="3" width="48" height="48" rx="6" fill="#E5EEFF" shapeRendering="crispEdges" />
                            <rect x="3" y="3" width="48" height="48" rx="6" stroke="#CEDEFF" shapeRendering="crispEdges" />
                            <circle cx="27" cy="27" r="9" stroke="#2056C1" strokeWidth="2" />
                            <line x1="18" y1="27" x2="36" y2="27" stroke="#2056C1" strokeWidth="2" />
                            <path d="M27 18a12 12 0 0 1 3 9 12 12 0 0 1-3 9 12 12 0 0 1-3-9 12 12 0 0 1 3-9z" stroke="#2056C1" strokeWidth="2" />
                          </g>
                          <defs>
                            <filter id="filter0_d_lp_url" x="0.5" y="0.5" width="57" height="57" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                              <feFlood floodOpacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                              <feOffset dx="2" dy="2" />
                              <feGaussianBlur stdDeviation="2" />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_lp_url" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_lp_url" result="shape" />
                            </filter>
                          </defs>
                        </svg>
                      </div>
                      <span style={{ fontWeight: 600, fontSize: '0.95rem' }}>Preview URL</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className={`campaign-accordion-chevron ${activeAccordionKeys.includes('1') ? 'open' : ''}`} aria-hidden="true">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <Container fluid className="px-0">
                    {!previewUrl ? (
                      <div className="py-3" style={{ color: '#6c757d', fontSize: '0.95rem' }}>
                        {selectedLp
                          ? 'No preview generated yet. Select a landing page and click Generate LP Preview.'
                          : 'Select a landing page first, then generate a preview.'}
                      </div>
                    ) : (
                      <Row className="mt-2">
                        <Col xs={12}>
                          <div style={{
                            display: 'flex', alignItems: 'center',
                            border: '1px solid #dee2e6', borderRadius: 8,
                            overflow: 'hidden', maxWidth: 580, background: '#fff',
                          }}>
                            <div style={{ padding: '0 10px', color: '#6c757d', flexShrink: 0 }}>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="2" y1="12" x2="22" y2="12" />
                                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                              </svg>
                            </div>
                            <a href={previewUrl} target="_blank" rel="noopener noreferrer" title={previewUrl}
                              style={{
                                flex: 1, padding: '8px 4px', fontSize: 12, color: '#495057',
                                textDecoration: 'none', overflow: 'hidden', whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis', display: 'block',
                              }}>
                              {previewBaseUrl}
                            </a>
                            <button
                              onClick={() => {
                                navigator.clipboard.writeText(previewUrl);
                                setCopied(true);
                                setTimeout(() => setCopied(false), 2000);
                              }}
                              style={{
                                padding: '8px 16px', color: '#000', border: 'none',
                                background: 'transparent', fontWeight: 500, fontSize: 12,
                                cursor: 'pointer', flexShrink: 0, whiteSpace: 'nowrap',
                              }}>
                              {copied ? 'Copied!' : 'Copy URL'}
                            </button>
                            <a href={previewUrl} target="_blank" rel="noopener noreferrer"
                              style={{
                                padding: '8px 12px', color: '#132848', display: 'flex',
                                alignItems: 'center', flexShrink: 0, textDecoration: 'none',
                              }}>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                <polyline points="15 3 21 3 21 9" />
                                <line x1="10" y1="14" x2="21" y2="3" />
                              </svg>
                            </a>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Container>
                </Accordion.Body>
              </Accordion.Item>

            </Accordion>
          </div>
        </>
      )}
    </div>
  );
};

export default LandingPagePreview;
